import { render, staticRenderFns } from "./VideosModal.vue?vue&type=template&id=0c706615&"
import script from "./VideosModal.vue?vue&type=script&lang=ts&"
export * from "./VideosModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports